import { render, staticRenderFns } from "./CamposCustomizados.vue?vue&type=template&id=cd5e6570"
import script from "./CamposCustomizados.vue?vue&type=script&lang=js"
export * from "./CamposCustomizados.vue?vue&type=script&lang=js"
import style0 from "./CamposCustomizados.vue?vue&type=style&index=0&id=cd5e6570&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports